require('./periodicLoadsTableInfoRow.scss');
// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @ commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTableRowDetails = require('components/rebrand/OKTableRowDetails/OKTableRowDetails');
const OKTableRowDetailsItem = require('components/rebrand/OKTableRowDetails/OKTableRowDetailsItem/OKTableRowDetailsItem');

// @ helpers
const { formatText } = require('core/i18n').i18n;
const { toCamelCase, getLastNChars } = require('utilities/stringHelper');

class PeriodicLoadsTableInfoRow extends React.Component {
    searchAssociatedAccountId(accountNumber) {
        const { immAccounts } = this.props;
        const product = accountNumber && accountNumber.substr(0,3);
        const contractNumber = accountNumber && accountNumber.substr(3);

        return immAccounts.get('byOrder').find((accountId) => {
            const account = immAccounts.getIn(['byId', accountId]);
            return account.get('contractNumber') === contractNumber && account.get('product') === product;
        });
    }

    buildDetailRowItem() {
        const { immTransaction, immAccounts } = this.props;
        const accountNumber = immTransaction.get('accountNumber');
        const accountObject = immAccounts.getIn(['byId', this.searchAssociatedAccountId(accountNumber)]);
        const originAccountAlias = accountObject.get('alias') || toCamelCase(accountObject.get('accountType'));
        const originAccountText = `${originAccountAlias} ${getLastNChars(accountObject.get('iban'))}`;
        return (
            <OKTableRowDetails title="cardPeriodicLoads-detailInfo">
                <OKTableRowDetailsItem
                    title={formatText('cardStatement-chargeAccount')}
                    value={originAccountText}
                />
            </OKTableRowDetails>
        );
    }

    render() {
        return(
            <OKTableRow>
                <OKTableCell />
                <OKTableCell colSpan={2}>
                    {this.buildDetailRowItem()}
                </OKTableCell>
                <OKTableCell />
                <OKTableCell />
                <OKTableCell />
            </OKTableRow>
        );
    }
}

PeriodicLoadsTableInfoRow.propTypes = {
    immAccounts: PropTypes.object,
    immTransaction: PropTypes.object.isRequired,
    match: PropTypes.object,
};

module.exports.constructor = PeriodicLoadsTableInfoRow;
module.exports.PeriodicLoadsTableInfoRow = connect(
    state => ({
        immAccounts: state.accounts,
    }), null
)(PeriodicLoadsTableInfoRow);
